import React from 'react';

import type { ModalsV2ContextType, ModalsV2State } from './ModalsV2Context';
import { ModalsV2Context } from './ModalsV2Context';

export const ModalsV2Provider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [state, setState] = React.useState<ModalsV2State>({});

  const openModal: ModalsV2ContextType['openModal'] = React.useCallback((component, props) => {
    setState(prevState => {
      return {
        ...prevState,
        [props.id]: {
          component,
          props,
        },
      };
    });
  }, []);

  const closeModal: ModalsV2ContextType['closeModal'] = React.useCallback(id => {
    setState(prevState => {
      return {
        ...prevState,
        [id]: undefined,
      };
    });
  }, []);

  const resetState: ModalsV2ContextType['resetState'] = React.useCallback(() => {
    setState({});
  }, []);

  const contextValue: ModalsV2ContextType = React.useMemo(() => {
    return { state, openModal, closeModal, resetState };
  }, [closeModal, openModal, resetState, state]);

  return <ModalsV2Context value={contextValue}>{children}</ModalsV2Context>;
};
